import {
  Modal,
  Spin,
  Row,
  Col,
  Button,
  Radio,
  Menu,
  Icon,
  Dropdown
} from "antd";
import React from "react";
import { strings } from "../../../helpers";

export default class ShowVerifyModal extends React.Component {
  /**
   * @function showStatus
   * @param status
   * @description This function will show selected status
   */
  showStatus = status => {
    let statusText = "";
    switch (status) {
      case "Select":
        statusText = `${strings.ticket_detail_view.Select}`;
        break;
      case "Checked with College":
        statusText = `${strings.ticket_detail_view.CheckedWithCollege}`;
        break;
      case "Checked with IMA":
        statusText = `${strings.ticket_detail_view.CheckedWithIMA}`;
        break;

      default:
        break;
    }
    return statusText;
  };

  render() {
    const {
      openVerifyModal,
      cancelShowVerifyModal,
      showVerify,
      onStatusFilter,
      selectedReason,
      verifyDoctor
    } = this.props;

    const menu = (
      <Menu onClick={onStatusFilter}>
        <Menu.Item key="Select">{strings.ticket_detail_view.Select}</Menu.Item>
        <Menu.Item key="Checked with College">
          {strings.ticket_detail_view.CheckedWithCollege}
        </Menu.Item>
        <Menu.Item key="Checked with IMA">
          {strings.ticket_detail_view.CheckedWithIMA}
        </Menu.Item>
      </Menu>
    );
    return (
      <Modal
        title={
          !showVerify
            ? `${strings.ticket_detail_view.VerifyDoctor}`
            : `${strings.ticket_detail_view.UnverifyDoctor}`
        }
        wrapClassName="vertical-center-modal carousal-modal"
        visible={openVerifyModal}
        width={500}
        onCancel={cancelShowVerifyModal}
        footer={null}
        destroyOnClose
      >
        <div>
          {!showVerify && (
            <Row type="flex">
              <Col span={12}>
                <p>{strings.ticket_detail_view.verifyReason}</p>
              </Col>
              <Col span={12} className="text-right">
                <Dropdown overlay={menu} trigger={["click"]}>
                  <Button size="small" className="reason-dropdown">
                    {this.showStatus(selectedReason)}
                    <Icon type="down" />
                  </Button>
                </Dropdown>
              </Col>
            </Row>
          )}
          {showVerify && (
            <Row type="flex">
              <Col span={16}>
                <p>{strings.ticket_detail_view.unverifyReason}</p>
              </Col>
            </Row>
          )}
          <Row className={!showVerify ? "modal-footer-row" : ""}>
            <Col span={24} className="text-right">
              <Button type="primary" onClick={verifyDoctor} size="small">
                {showVerify
                  ? `${strings.ticket_detail_view.Unverify}`
                  : `${strings.ticket_detail_view.Verify}`}
              </Button>
              <Button
                className="ml-8"
                onClick={cancelShowVerifyModal}
                size="small"
              >
                {strings.schedule.cancel}
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    );
  }
}
